import React from 'react';
import {Button, Image} from 'antd-mobile';
import SportSwiperCard, {SportsItem} from './swiper-card';

const floorHeaderBg = require('@/pages/home/v2/assets/header-bg/live.webp');
const floorHeaderStyle = {
  backgroundImage: `url(${floorHeaderBg})`,
};

interface SportFloorProps {
  icon: string;
  title: string;
  hasLink?: boolean;
  hasLiveIcon?: boolean;
  sportsList: SportsItem[];
  isSport?: boolean;
  defaultSportIcon?: string;
  onLinkClick?: () => void;
}

const PreIcon = () => {
  return (
    <Button className="bg-[var(--live-bg)] text-white rounded-[0.325rem] text-xs w-[2.5rem] h-[1.2rem] font-size-10 flex items-center justify-center">
      Live
    </Button>
  );
};

const SportFloor = ({
  icon,
  title,
  hasLink,
  hasLiveIcon,
  isSport,
  sportsList,
  defaultSportIcon,
  onLinkClick,
}: SportFloorProps) => {
  return (
    <div className="flex flex-col overflow-hidden">
      <div
        className="flex h-12 flex-row items-center justify-between rounded-t-[1rem] bg-full bg-no-repeat px-3"
        style={floorHeaderStyle}>
        <div className="flex flex-row gap-2 items-center">
          <Image src={icon} className="size-7 object-contain" />
          <span
            onClick={() => hasLink && onLinkClick?.()}
            className="text-sm font-bold text-t1">
            {title}
          </span>
          {hasLiveIcon && <PreIcon />}
        </div>
        {hasLink && (
          <div
            onClick={onLinkClick}
            className="rounded-lg border border-[#9FA6AC] bg-white px-2 py-1 text-c1 text-xs font-bold leading-none">
            All
          </div>
        )}
      </div>
      <div className="w-full pb-3">
        <div className="flex flex-row gap-2 items-center overflow-x-auto hide-scrollbar pl-2 pr-2">
          {sportsList?.map((item, index) => (
            <SportSwiperCard
              key={index}
              item={item}
              isLive={item.isLive}
              isSport={isSport}
              isMix={true}
              icon={defaultSportIcon}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default SportFloor;
